import BlogPost from "../components/items/BlogPost"
import BlogPostArticleItem from "../components/items/BlogPostArticleItem"
import doctorWithRoboticArm from '../people/Rectangle 31.png'
import '../css/Blog.css'
import { motion } from 'framer-motion'

function Blog() {
  return (
    <>
    <motion.main 
        id="blog"
        initial={{width: 0}}
        animate={{width: '100%'}}
        exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
        <BlogPostArticleItem 
            post_img={doctorWithRoboticArm}
            summary="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
            author="Habeeb Lawal"
            date_posted="13th May, 2023"
            heading="Impact of AI in the healthcare sector"
        />
        <section className="blog">
            <ul className="blogposts">
                <BlogPost 
                    heading="Impact of AI in the healthcare sector"
                    author="Habeeb Lawal"
                    date_posted="13th May, 2023"
                    summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                />
                <BlogPost 
                    heading="Impact of AI in the healthcare sector"
                    author="Habeeb Lawal"
                    date_posted="13th May, 2023"
                    summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                />
                <BlogPost 
                    heading="Impact of AI in the healthcare sector"
                    author="Habeeb Lawal"
                    date_posted="13th May, 2023"
                    summary="Impact of AI in the healthcare sector. We could see that from the advent of technology in the year 1990 that the invention of machine learning and artificial intelligence"
                />
            </ul>
        </section>
    </motion.main>
    </>
  )
}

export default Blog